module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentCart && _vm.notBenchmark),
      expression: "currentCart && notBenchmark"
    }],
    staticClass: "cart-wrapper"
  }, [_c('div', {
    staticClass: "cart-header-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandImg,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cart-summary-wrapper"
  }, [_c('div', {
    staticClass: "cart-products-summary-wrapper"
  }, _vm._l((_vm.currentProducts), function(product) {
    return _c('div', {
      staticClass: "cart-product-detail"
    }, [_c('span', {
      staticClass: "cart-product-image-wrapper"
    }, [_c('img', {
      staticClass: "cart-product-image",
      attrs: {
        "src": product['product-images'][0]
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "cart-product-name"
    }, [_vm._v("\n          " + _vm._s(product.name) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "cart-product-price"
    }, [_vm._v("\n          $" + _vm._s(product.price) + "\n        ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "cart-summary-heading"
  }, [_vm._v("\n      Loading product on " + _vm._s(_vm.currentBrand && _vm.currentBrand.brandName) + "\n    ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "iframe-cart-holder"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-wrapper"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-1x fa-fw"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-263441e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/CartSummary.vue
// module id = 37
// module chunks = 0